export const mapBreadcrumbs = (breadcrumbs) =>
  (breadcrumbs || []).map(
    ({ linkUrl, friendlyName: Label, id: CategoryId }) => ({
      Url: linkUrl,
      Label,
      CategoryId,
    }),
  );
